import { render, staticRenderFns } from "./GetInvolved.vue?vue&type=template&id=58ce3895&scoped=true&"
import script from "./GetInvolved.vue?vue&type=script&lang=js&"
export * from "./GetInvolved.vue?vue&type=script&lang=js&"
import style0 from "./GetInvolved.vue?vue&type=style&index=0&id=58ce3895&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ce3895",
  null
  
)

export default component.exports